import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu-shared-company-reform-areas', class extends Controller {
  static targets = [
    'reformContent',
    'reformButton',
    'reformToggleText',
    'reformToggleIcon',
    'makerContent',
    'makerButton',
    'makerToggleText',
    'makerToggleIcon'
  ]

  connect() {
    // 初期化時に3行を超えるかチェックしてボタン表示を制御
    this.checkOverflow()
    // リサイズ時にも再チェック
    window.addEventListener('resize', this.checkOverflow.bind(this))
  }

  disconnect() {
    window.removeEventListener('resize', this.checkOverflow.bind(this))
  }

  checkOverflow() {
    // PCサイズでは何もしない
    if (window.innerWidth >= 768) {
      return
    }

    const twoLineHeight = 75

    // リフォームセクションのチェック
    if (this.hasReformContentTarget && this.hasReformButtonTarget) {
      const reformContent = this.reformContentTarget
      // 一時的に制限を外して実際の高さを測定
      reformContent.classList.add('no-overflow')
      const actualHeight = reformContent.scrollHeight
      reformContent.classList.remove('no-overflow')

      // 3行以上（2行を超える）かどうか
      const needsMoreButton = actualHeight > twoLineHeight

      if (needsMoreButton) {
        this.reformButtonTarget.classList.add('is-visible')
        reformContent.classList.remove('no-overflow')
      } else {
        this.reformButtonTarget.classList.remove('is-visible')
        reformContent.classList.add('no-overflow')
      }
    }

    // メーカーセクションのチェック
    if (this.hasMakerContentTarget && this.hasMakerButtonTarget) {
      const makerContent = this.makerContentTarget
      // 一時的に制限を外して実際の高さを測定
      makerContent.classList.add('no-overflow')
      const actualHeight = makerContent.scrollHeight
      makerContent.classList.remove('no-overflow')

      // 3行以上（2行を超える）かどうか
      const needsMoreButton = actualHeight > twoLineHeight

      if (needsMoreButton) {
        this.makerButtonTarget.classList.add('is-visible')
        makerContent.classList.remove('no-overflow')
      } else {
        this.makerButtonTarget.classList.remove('is-visible')
        makerContent.classList.add('no-overflow')
      }
    }
  }

  toggleReform() {
    const content = this.reformContentTarget
    const button = this.reformButtonTarget
    const isExpanded = content.classList.contains('is-expanded')

    if (isExpanded) {
      content.classList.remove('is-expanded')
      button.classList.remove('is-expanded')
      this.reformToggleTextTarget.textContent = 'もっと見る'
    } else {
      content.classList.add('is-expanded')
      button.classList.add('is-expanded')
      this.reformToggleTextTarget.textContent = '閉じる'
    }
  }

  toggleMaker() {
    const content = this.makerContentTarget
    const button = this.makerButtonTarget
    const isExpanded = content.classList.contains('is-expanded')

    if (isExpanded) {
      content.classList.remove('is-expanded')
      button.classList.remove('is-expanded')
      this.makerToggleTextTarget.textContent = 'もっと見る'
    } else {
      content.classList.add('is-expanded')
      button.classList.add('is-expanded')
      this.makerToggleTextTarget.textContent = '閉じる'
    }
  }
})
